/**
 * 异步加载百度地图 Web API 及可选的 TrackAnimation 插件。
 *
 * @param {string} ak - 百度地图 API Key
 * @param {boolean} [type=false] - 是否加载 TrackAnimation 插件，默认不加载
 * @returns {Promise<void>} - 当百度地图主库及可选插件加载完成后，返回 Promise.resolve()
 */
export default async function loadBaiduMap(ak, type = false) {
  return new Promise((resolve) => {

    let isbaidu = false
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i].src.includes('api.map.baidu.com')) {
        isbaidu =  true;
      }
    }
    if(isbaidu)true

    const script = document.createElement('script');

    script.src = `https://api.map.baidu.com/api?type=webgl&v=3.0&ak=${ak}&callback=initBaiduMap`;
    script.async = true;

    document.head.appendChild(script);

    window.initBaiduMap = () => {
      //轨迹动画,
      if (type) {
        const pluginScript = document.createElement('script');
        pluginScript.type = 'text/javascript';
        pluginScript.src = 'https://api.map.baidu.com/library/TrackAnimation/src/TrackAnimation_min.js';
        document.head.appendChild(pluginScript);
      }

      // 当主库加载完成时，始终调用 resolve()。如果有额外插件，插件将在之后加载。
      resolve();
    };
  });
}


